import React from 'react';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import RoleService from '../../Services/roleService';
import InputWithClearBase from './InputWithClearBase';
import ErrorMessage from '../ErrorMessage';
import { getInputRenderer } from './renderers';

/**
 * Stateful wrapper around an input field. Responsibilities:
 *  - run the optional `validityChecker` and surface its error message,
 *  - resolve the (possibly function-valued) `labelText` / `disabled` props and the RBAC gate,
 *  - delegate the actual field rendering to the renderer registry (see `./renderers`),
 *  - hand everything to `InputWithClearBase` for the label / eraser / error chrome.
 *
 * The mapping from `InputTypesEnum` to a concrete field lives in `./renderers`; to add a new
 * input type, add a renderer there (or a row in `renderers/lookupSelectConfig.js` for a plain
 * lookup select) — this component does not need to change.
 */
export default class InputWithClear extends React.Component {
  static defaultProps = {
    className: 'w-100 form-control form-control-sm',
    changeOfEditedMultipItem: () => {},
    disableClearButton: false,
    disabled: false,
    displayHyperlink: false,
    editedItem: null,
    errorMessage: '',
    EntityId: -1,
    EntityTypeId: -1,
    fieldName: 'defaultFieldname',
    filterCleared: false,
    idFilter: -1,
    info: '',
    IsCheckBoxEnabled: false,
    isInOneRow: false,
    labelIsDisabled: false,
    labelText: 'Default Label Text',
    margin: 'm-1',
    maxLength: null, // optional character cap for text inputs; null leaves the input uncapped
    multipleIdFilter: null,
    numberOfRows: 8,
    officeId: '',
    onChange: () => {},
    onOffValue: '',
    placeholder: '',
    renderedInputField: null,
    roleKey: null,
    selectValues: [],
    showSelectFilterAt: 10,
    tooltipText: null,
    type: InputTypesEnum.Text,
    validityChecker: null,
    value: null,
    dateAsUtc: false, //for Date inputs: keep the calendar day timezone-independent (see CaspianDatePicker.utc)
    acceptedTypes: '*', //for FileUploadField
    rawFileFieldName: 'RawFile', //for FileUploadField
    fileTemplateFunction: null, //for FileUploadField
    textBeforeInput: null, //for TextField
    getCheckBoxFieldsObject: null, //for CheckBox fields where the inputs are dynamic based on an array
    separatorCharacter: ',', //for LookupItemMiscMultiChoice
    lookupItemId: -1, //for LookupItemMiscMultiChoice
  };

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: props.errorMessage,
    };
  }

  componentDidMount() {
    this.validityChecker();
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.editedItem) !== JSON.stringify(this.props.editedItem) ||
      JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)
    ) {
      this.setState({ errorMessage: '' });
      this.validityChecker();
    }
  }

  validityChecker() {
    if (this.props.validityChecker) {
      const validation = this.props.validityChecker(this.props.value, this.props.editedItem);
      Promise.resolve(validation)
        .then((error) => {
          if (error !== '' && error !== undefined) {
            this.setState({ errorMessage: error });
          }
        })
        .catch(() => ErrorMessage.SetErrorMessage('IWC138'));
    }
  }

  renderInputField() {
    return getInputRenderer(this.props.type)(this.props);
  }

  render() {
    const labelText =
      typeof this.props.labelText === 'function' ? this.props.labelText(this.props.editedItem) : this.props.labelText;

    const disabled =
      (typeof this.props.disabled === 'function' ? this.props.disabled(this.props.editedItem) : this.props.disabled) ||
      (this.props.roleKey && !RoleService.CheckUserPermission('inputfield', this.props.roleKey));

    return (
      <InputWithClearBase
        disableClearButton={this.props.disableClearButton}
        disabled={disabled}
        displayHyperlink={this.props.displayHyperlink}
        errorMessage={this.state.errorMessage}
        fieldName={this.props.fieldName}
        info={this.props.info}
        isInOneRow={this.props.isInOneRow}
        labelIsDisabled={this.props.labelIsDisabled}
        labelText={labelText}
        margin={this.props.margin}
        onChange={this.props.onChange}
        renderedInputField={this.renderInputField()}
        tooltipText={this.props.tooltipText}
        type={this.props.type}
        value={this.props.value}
      />
    );
  }
}
